var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.68;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:1.68;stroke-miterlimit:10;}\r\n\t.st4{opacity:0.6314;}\r\n\t.st5{opacity:0.9804;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.56,26.04H4.44c-0.97,0-1.75-0.8-1.75-1.79V3.45c0-0.98,0.79-1.79,1.75-1.79h4.59v1.68H4.44 c-0.04,0-0.07,0.04-0.07,0.11v20.81c0,0.06,0.04,0.11,0.07,0.11h17.12c0.04,0,0.07-0.05,0.07-0.11V3.45c0-0.06-0.04-0.11-0.07-0.11 h-4.71V1.66h4.71c0.97,0,1.75,0.8,1.75,1.79v20.81C23.31,25.24,22.53,26.04,21.56,26.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.32,1.68v1.79H9.68V1.68H16.32 M16.5,0h-7C8.67,0,8,0.67,8,1.5v2.15c0,0.83,0.67,1.5,1.5,1.5h7 c0.83,0,1.5-0.67,1.5-1.5V1.5C18,0.67,17.33,0,16.5,0L16.5,0z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19,17.47l0-1.18c0-0.14,0.11-0.25,0.25-0.25l9.12-0.01c0.14,0,0.25,0.11,0.25,0.25l0,1.18c0,0.14-0.11,0.25-0.25,0.25 l-9.12,0.01C8.3,17.72,8.19,17.61,8.19,17.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.56,13.7c-0.03,0-0.05,0-0.08,0c-0.33-0.03-0.63-0.2-0.81-0.47l-1.14-1.7l-0.91-1.53l-0.8,1.91l-3.14,0 c-0.14,0-0.25-0.11-0.25-0.25l0-1.18c0-0.14,0.11-0.25,0.25-0.25l2.03,0l0.85-2.03c0.15-0.37,0.5-0.61,0.9-0.64 c0.4-0.04,0.77,0.17,0.97,0.51l1.52,2.57l0.68,1.02l1.33-1.43l2.36,0c0.14,0,0.25,0.11,0.25,0.25l0,1.18 c0,0.14-0.11,0.25-0.25,0.25l-1.63,0l-1.35,1.46C15.14,13.57,14.86,13.7,14.56,13.7z M14.12,12.21 C14.12,12.21,14.11,12.21,14.12,12.21L14.12,12.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19,21.21l0-1.18c0-0.14,0.11-0.25,0.25-0.25l9.12-0.01c0.14,0,0.25,0.11,0.25,0.25l0,1.18c0,0.14-0.11,0.25-0.25,0.25 l-9.13,0.01C8.3,21.46,8.19,21.34,8.19,21.21z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.5779be3c2012600f82a582202ccc3fcf.svg";
export { ForwardRef as ReactComponent };